module.exports = __webpack_public_path__ + "static/media/D_K.0ba44d82.png";